import axios from "axios";
import { API_BASE_URL } from "./config";

// URL backend propre (Railway) — TOUJOURS inclure /api ici
const baseURL =
  API_BASE_URL && API_BASE_URL.startsWith("http")
    ? API_BASE_URL
    : "https://www.crush-now.fr/api";

console.log("🌍 Axios baseURL =", baseURL);

const instance = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Ajouter automatiquement le token
instance.interceptors.request.use((config) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch (err) {
    console.warn("⚠️ Impossible de lire le token :", err);
  }
  return config;
});

// Routes où un 401 est une réponse métier normale (mauvais identifiants, mauvaise phrase de récupération,
// mauvais mot de passe de confirmation) — ne pas déconnecter l'utilisateur dans ces cas.
const BUSINESS_401_ROUTES = [
  "/auth/login",
  "/auth/register",
  "/auth/register-pseudo",
  "/auth/recover",
  "/auth/delete-account",
];

const AUTH_PAGES = [
  "/login",
  "/register",
  "/recover",
  "/forgot-password",
  "/reset-password",
  "/recover-account",
];

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url ?? "";
      const isBusinessRoute = BUSINESS_401_ROUTES.some((r) => url.includes(r));
      const isAuthPage = AUTH_PAGES.includes(window.location.pathname);

      if (!isBusinessRoute && !isAuthPage) {
        localStorage.removeItem("user");
        localStorage.removeItem("fcm_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
